<template>
  <div class="lmf_tree_view">
    <div class="el-tree-node__content" style="display: flex;padding: 0 5px 0 0;align-items:center;position:relative;">
      <span v-if="(oneTreeData.children && oneTreeData.children.length > 0)" :class="'el-tree-node__expand-icon el-icon-caret-right-hollow '+(openType?'expanded':'')" @click="changeOpenType" ></span>
      <div class="treeListItem" :style="pageSetInfo.listStyleSet.listPageTreeFirstStyleSet?pageSetInfo.listStyleSet.listPageTreeFirstStyleSet.styleSetCode:''" kwName="listPageTreeFirstStyleSet" @click="changeOpenType">
        <kw_icon v-if="(oneTreeData.TYPE_ICON)" :type="(oneTreeData.TYPE_ICON)" />
        <span class="treeTitle" :style="pageSetInfo.listStyleSet.listPageTreeTitleStyleSet?pageSetInfo.listStyleSet.listPageTreeTitleStyleSet.styleSetCode:''" kwName="listPageTreeTitleStyleSet">{{prevIndex+(prevIndex!=''?'_':'')+nowIndex}} {{oneTreeData.NAME}}</span><span>{{oneTreeData.STUDY_DATE}}</span>
        <kw_btn_array v-if="(pageSetInfo.operaButtonSet && pageSetInfo.operaButtonSet.length>0 && pageSetInfo.operaButtonSetIfHide)" :pageSetInfo="pageSetInfo" :dataInfo="oneTreeData" :dataIndex="oneTreeData.list_index" @dataButtonClick="dataButtonClick" :isLimitButton="isLimitButton"></kw_btn_array>
      </div>
    </div>
    <div class="el-tree-node__children roleGroup" v-if="(oneTreeData.children && oneTreeData.children.length > 0)" v-show="openType" :style="pageSetInfo.listStyleSet.listPageTreeLoopStyleSet?pageSetInfo.listStyleSet.listPageTreeLoopStyleSet.styleSetCode:''" kwName="listPageTreeLoopStyleSet" >
      <div class="outLineTreeBox">
        <div role="tree" class="el-tree LineTree" :style="pageSetInfo.listStyleSet.listPageTreeOutermostBoxStyleSet?pageSetInfo.listStyleSet.listPageTreeOutermostBoxStyleSet.styleSetCode:''" kwName="listPageTreeOutermostBoxStyleSet">
          <div role="treeitem" class="el-tree-node is-expanded is-focusable" v-for="(item,index) in oneTreeData.children" :key="index" :style="pageSetInfo.listStyleSet.listPageTreeListBoxStyleSet?pageSetInfo.listStyleSet.listPageTreeListBoxStyleSet.styleSetCode:''" kwName="listPageTreeListBoxStyleSet">
            <lmf_tree_view :pageSetInfo="pageSetInfo" :oneTreeData="item" :treeIndex="treeIndex+1" :prevIndex="prevIndex+(prevIndex!=''?'_':'')+nowIndex" :nowIndex="(index+1)+''" ></lmf_tree_view>
          </div>
        </div>
      </div>
      <!-- <lmf-tree treeData="{{oneTreeData.children}}" treeIndex="{{treeIndex+1}}" prevIndex="{{prevIndex+(prevIndex!=''?'_':'')+nowIndex}}" nowIndex="{{nowIndex}}" pageSetInfo="{{pageSetInfo}}"></lmf-tree> -->
    </div>
  </div>
</template>

<script>
// 列表的按钮组件
import kw_btn_array from '@/components/look/kw_btn_array.vue';
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'lmf_tree_view',
  props: {
    oneTreeData:{
      type: Object,
      value: {}
    },
    treeIndex: {
      type: Number,
      value: 1
    },
    prevIndex: {
      type: String,
      value: ""
    },
    nowIndex: {
      type: String,
      value: ""
    },
    pageSetInfo:{
      type: Object,
      value: null
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      openType:false
    };
  },
  created() {

  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
    kw_btn_array
  },
  methods: {
    changeOpenType:function(){
      this.openType = !this.openType;
    },
    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (detail,dataInfo) {
      pageUtils.dataButtonClick(this,detail,dataInfo);
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*课程树*/
.el-tree{position: relative;cursor: default;background: #fff;color: #606266;}
.el-tree-node__expand-icon{cursor: pointer;color: #c0c4cc;font-size: 12px;-webkit-transform: rotate(0);transform: rotate(0);-webkit-transition: -webkit-transform .3s ease-in-out;transition: -webkit-transform .3s ease-in-out;transition: transform .3s ease-in-out;transition: transform .3s ease-in-out, -webkit-transform .3s ease-in-out;transition: transform .3s ease-in-out,-webkit-transform .3s ease-in-out;}
.el-icon-caret-right:before{content: '';display: inline-block;width: 0;height: 0;overflow: hidden;border: 7px solid transparent;border-left-color: #9096ac;border-right-width: 0;margin: 5px 2.5px;}
.el-icon-caret-right-hollow:before{content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-top: 1px solid #656565;
    border-right: 1px solid #656565;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    /*margin: 5px 2.5px;*/
    margin: 0 5px;
}

.outLineTreeBox .el-tree{background: #eff3f6;overflow: hidden;padding-bottom: .5rem;}
.outLineTreeBox .el-tree-node__expand-icon{color: #9096ac;font-size: 1.2rem;padding: 6px;font-family: element-icons!important;speak: none;font-style: normal;font-weight: 400;font-variant: normal;text-transform: none;line-height: 1;vertical-align: baseline;display: inline-block;-webkit-font-smoothing: antialiased;-moz-osx-font-smoothing: grayscale;}
.outLineTreeBox .el-tree-node__content{padding: .5rem;margin: .4rem;margin-bottom: 0;background: #fff;cursor: auto;display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-align: center;-ms-flex-align: center;align-items: center;height: 26px;cursor: pointer;}
.outLineTree{width: 100%;position: relative;overflow: hidden;}
.outLineTree span{padding: 0 .2rem;vertical-align: middle;}
.outLineTree .TreeType{display: inline-block;}
.outLineTree .TreeType:after{content: '：';}
.roleGroup .roleGroup .roleGroup .TreeType:before{content: '';display: inline-block;width: 1.2rem; height: 1rem;margin-right: .5rem;background: url() no-repeat center;background-size: 100% 100%;vertical-align: -1px;}
/*.outLineTree .TreeName{font-weight: bold;}*/
.outLineTree .TreeName{font-weight: bold;font-size: 14px}
.roleGroup .roleGroup .TreeName{font-weight: normal;}
/*.outLineTree .TreeDate{}*/
.outLineTree .TreeDate:before{content: '-';}
.outLineTree .TreeBuy{float: right;min-width: 3em;padding: .2rem 0;text-align: center;font-size: 14px}
.outLineTree .TreeBtn{float: right;min-width: 6em;border-radius: 3em;color: #fff;padding: .2rem 0;text-align: center;margin-right: .5rem;}
.TreeBtn{background: #c1c1c1;}/*默认*/
.EnterStudio{background: #ff494b;cursor: pointer;}/*进入直播*/
.NotTime{background: #ff9c00;cursor: pointer;}/*未开始*/
.LookStudio{background: #6d5bff;cursor: pointer;}/*回看*/
.download{background: transparent;cursor: pointer;}/*点击下载*/
span.download image{display: inline-block;width: 1.5rem;height: 1.5rem;}/*点击下载*/
/*.Ununlocked{}不可做*/
/*.Rolls{}未完成*/
.CheckRolls{background: #15ba6b;cursor: pointer;}/*查看*/
.CheckRolls:before{content: '';background: url() no-repeat center;background-size: 100% 100%;display: inline-block;width: 1.15rem;height: 1.15rem;margin-right: .2rem;vertical-align: -3px;}/*回看*/

.el-tree-node__expand-icon.is-leaf{color: transparent;cursor: default;visibility: hidden;}
.el-tree-node__expand-icon.expanded{-webkit-transform: rotate(90deg);transform: rotate(90deg);}

.roleGroup .roleGroup .roleGroup .TreeType:before{background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBDREI2QTA5QTg2MTExRTk5RjlBRUE4NUIxQUUxRTdGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBDREI2QTBBQTg2MTExRTk5RjlBRUE4NUIxQUUxRTdGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MENEQjZBMDdBODYxMTFFOTlGOUFFQTg1QjFBRTFFN0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MENEQjZBMDhBODYxMTFFOTlGOUFFQTg1QjFBRTFFN0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4+GbfMAAAA60lEQVR42mL8//8/AzUB4/9WpSogXQjEIljkG4C4Ea8JVXcxDIQ58QgQM0HZf4FYDIjVgfgAEHsA8U9SDDwIxA5YlCcB8Vwg/gfEC4EYV/gwAvEXIN4JM/A4EFvhUKwCUgjESsSEIROSDbjAHSBWBmI+AngGSDELCRH4GW8Ytil/ImSgLBD7QsMPF2AGGnQHaCgoSNgJGWgGxFOJcPlJaBj/I2TgdiDWIOhCBoaPyPGBz8BvQHyToPsQ6ZAJOZapBkawgV+pYNYb5MIBlDQmE8iC+ABIfyAQy4MMbAUy0oFYmEIXgoq3dQABBgAZ1j3BGTimMAAAAABJRU5ErkJggg==);}
.CheckRolls:before{background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjRBOEJBNTFFQTg2MTExRTk4OUY3QzcyNkZFNDA5NTVGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjRBOEJBNTFGQTg2MTExRTk4OUY3QzcyNkZFNDA5NTVGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NEE4QkE1MUNBODYxMTFFOTg5RjdDNzI2RkU0MDk1NUYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NEE4QkE1MURBODYxMTFFOTg5RjdDNzI2RkU0MDk1NUYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5xHReMAAABdUlEQVR42pTUTygEURzA8aEc5ODgz8FJykpOS2rlb2qT5OYgV3FyUOvgQi6kJBcn5bQHB+2BXIbDlovUOqxsSflzcEOK2vJnG99ffsM0vRnm1WfnzXvv95s3O78Zy3Ecy2AQB3jGOz7xhCOMmmLK5MfTWpBGJy5gI48SWjGMDlxq/+4n0pd5CtdoD9ipiCHnfLded9ydrEBTSLDJtiZr9N5aDm/otqK1czSgVjLHNXN/hN1U6bFSY8flxMZthCTzGhzX82PcSOcFK/9MMqtJ8qjRsWkpEel8yNY8i1NYNiSZ0yS2b7xHakw6JYx5JtY0IOMZW9exHcMFutxERSz4Jpc0cENrKyiJmHBv7QQFw4JF57elQ/63PTxKJ6mL6wyLVrH7xwOQlnJP7nEVsbLFqSayyrVCE2jGVsTKlpc66X9pBzR7FvUhu6jGJhJhn5EYsvr+HGIfBcjO2zCEERTRh7Ogz4hrUqtXPmwPenzVpztjivkSYADvA07CGrMU1AAAAABJRU5ErkJggg==);}

.treeTitle{font-size: 15px;color: #3E3E3F;}
</style>
